import React from 'react';
import ComingSoonPage from '../../components/common/ComingSoonPage';

export const StudentSettingsPage: React.FC = () => {
  return <ComingSoonPage title="Settings" description="This feature is under development." />;
};

export default StudentSettingsPage;

